export default {
    namespaced: true,
    state: {
        products: {},
        total: 0,
        pageSize: 2
    },
    getters: {
        getProducts: state => state.products
    },
    mutations: {
        setProducts(state, products) {
            let result = {};
            products.forEach(product => {
                result[product.id] = product;
            });
            state.products = result;
            state.total = products.length;
        },
        setTotal(state, value) {
            state.total = value;
        },
        removeProduct(state, productId) {
            let result = Object.assign({}, state.products);
            if (productId && result && result[productId]) {
                delete result[productId];
            }

            state.products = result;
        }
    },
};
